import React from "react";
import Wrapper from "../../Wrapper";
import Borda from "../../../img/border-bottom.svg";

export default function Personalidade() {
    return (
        <Wrapper slice="50" src={Borda} column_end="span 2">
            <p>Movida por questionamentos e curiosidade, eu sempre quero aprender como as coisas funcionam e como posso fazê-las funcionar. Tendo um objetivo claro em mente, eu fico obcecada em cumpri-lo, e custa-me descansar enquanto não encontro uma solução a um problema.</p>
            <h3>Personalidade</h3>
        </Wrapper>
    )
}